<template>
  <OuterCasing class="main user-select"
               :style="'background: url(' + require('$merchantAsserts/images/login.jpg') + '); background-size:cover;'">
    <router-view/>
  </OuterCasing>
</template>

<script>
//  $common/components/outer-casing 这个组件是为了提供一个多页面加共同功能的东西来包裹的
import OuterCasing from '$common/components/outer-casing';

export default {
  components: {OuterCasing}
};
</script>
<style lang="stylus">
@import "./assets/css/common/main.css";
@import "./assets/css/common/reset.css";
@import "./assets/css/common/common.styl";
</style>
<style lang="stylus" scoped>
.main {
  min-width: 1024px !important;
  overflow hidden
}
</style>
